import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAuthenticationMethod } from 'app/security/core/typings/IAuthentication';
import { AuthenticationListUtils } from '../utils/authentication-list.utils';

@Component({
  selector: 'security-auth-list',
  templateUrl: './security-auth-list.component.html',
  styleUrls: ['./security-auth-list.component.scss']
})
export class SecurityAuthListComponent {
  public items: any;

  @Input() selectedMethod: IAuthenticationMethod;
  @Input() selectedMetadata: any;
  @Input() selectItemInput: any;

  @Output() selectItem = new EventEmitter<any>();

  constructor(private _authListUtils: AuthenticationListUtils) { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.items = this._authListUtils.processAuthenticationItems(this.selectedMethod, this.selectedMetadata);
  }

  onSelectItem(item: any) {
    this.selectItem.emit(item);
  }
}
